import { ClassValue } from 'clsx';
import { ReactNode } from 'react';
import { UseFormRegisterReturn } from 'react-hook-form';

import { cn } from '@/utils/styles';

import { colors, sizes } from './constants';
import { RadioColor, RadioSize } from './types';

export type RadioProps = {
  readonly id?: string;
  readonly value: string;
  readonly size?: RadioSize;
  readonly color?: RadioColor;
  readonly autoComplete?: string;
  readonly registration?: Partial<UseFormRegisterReturn>;
  readonly children?: ReactNode;
  readonly classes?: {
    main?: ClassValue;
    input?: ClassValue;
    label?: ClassValue;
  };
};

export function Radio({
  id,
  value,
  size = 'md',
  color = 'primary',
  autoComplete = 'off',
  registration,
  children,
  classes,
}: RadioProps) {
  return (
    <div className={cn('flex items-center justify-start gap-x-2', classes?.main)}>
      <input
        type="radio"
        id={id ?? value}
        autoComplete={autoComplete}
        className={cn(
          'cursor-pointer transition disabled:cursor-not-allowed',
          sizes[size],
          'appearance-none rounded-full border shadow-none outline-none',
          'focus:outline-none',
          'focus:ring-2 focus:ring-offset-0',
          colors[color],
          classes?.input
        )}
        value={value}
        {...registration}
      />

      {children ? (
        <label
          htmlFor={id ?? value}
          className={cn(
            'block text-base leading-4 font-normal',
            registration?.disabled ? 'text-neutral-disabled cursor-not-allowed' : 'text-base-primary cursor-pointer',
            classes?.label
          )}
        >
          {children}
        </label>
      ) : null}
    </div>
  );
}
